/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown>, reps: NonNullable<unknown> }} Plan_Warmup_SetInputs */

const en_us2_plan_warmup_set = /** @type {(inputs: Plan_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% × ${i?.reps}`)
};

const pt_br2_plan_warmup_set = /** @type {(inputs: Plan_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% × ${i?.reps}`)
};

const es_419_plan_warmup_set = /** @type {(inputs: Plan_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% × ${i?.reps}`)
};

const pt_pt2_plan_warmup_set = /** @type {(inputs: Plan_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% × ${i?.reps}`)
};

const fr_fr2_plan_warmup_set = /** @type {(inputs: Plan_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} % × ${i?.reps}`)
};

const de_de2_plan_warmup_set = /** @type {(inputs: Plan_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% × ${i?.reps}`)
};

const it_it2_plan_warmup_set = /** @type {(inputs: Plan_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "{pct}% × {reps}" |
*
* @param {Plan_Warmup_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_warmup_set = /** @type {((inputs: Plan_Warmup_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Warmup_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_warmup_set(inputs)
	if (locale === "es-419") return es_419_plan_warmup_set(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_warmup_set(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_warmup_set(inputs)
	if (locale === "de-DE") return de_de2_plan_warmup_set(inputs)
	if (locale === "it-IT") return it_it2_plan_warmup_set(inputs)
	return en_us2_plan_warmup_set(inputs)
});
export { plan_warmup_set as "plan.warmup_set" }